
import { defineComponent, PropType, computed } from "vue";
export default defineComponent({
  props: {
    /**
     * @param {Array} layout 描述布局
     */
    layout: {
      type: Array as PropType<any[]>,
      default: (): PropType<any[]> => [],
    },

    /**
     *@param {Array} data 描述数据
     */
    data: {
      type: Object as PropType<any>,
      default: () => {
        return {};
      },
    },

    /**
     * @param {Object} 依赖的数据源
     */
    //   source: {
    //      type: Object as PropType<any>,
    //      default: (): any => {
    //         return {};
    //      },
    //   },
  },
  setup(props) {
    /**
     * @method createLayout 生成描述布局
     */
    const createLayout = computed((): any => {
      /**
       * @param MAX_GRID    默认 最大栅格数
       */
      const MAX_GRID = 24;
      let index = 0;
      const layoutMulti: any = [];

      const layout: any[] = props.layout.filter((elmeent: any) => {
        // 优化diff
        elmeent.id = Number(
          Math.random().toString().substr(3, 8) + Date.now()
        ).toString(8);

        !elmeent.span ? (elmeent.span = 6) : false;
        return true;
      });

      // 转换成二维数组
      for (let element of layout) {
        if (layoutMulti[index]) {
          const sum = layoutMulti[index]
            .map((el: any) => el.span)
            .reduce((sum: number, nex: number) => sum + nex);

          if (sum >= MAX_GRID) {
            index++;
            layoutMulti.push([element]);
          } else {
            layoutMulti[layoutMulti.length - 1].push(element);
          }
        } else {
          layoutMulti.push([element]);
        }
      }

      return layoutMulti;
    });

    return {
      createLayout,
    };
  },
});
